<div class="row auto-complete-equal com-doc-head eip-mt-10">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="d-flex justify-content-end">
            <div style="width:21%;" class="justify-content-end align-items-right">
                <EIPAutoComplete ShowTextValueField='N' [SingleValueBind]="false" setId="transmittalTemplate" TextField="template_Name"  ValueField="template_Id" WaterMarkText="Choose Template" [IsCascading]='true' [dataSource]='templateDetails' ShowTextValueField='N' (valueChange)='changeTransmittalTemplateList($event)'>
                </EIPAutoComplete>
            </div>
            <div style="width:20%" class="justify-content-start align-items-left">
                <button class="btn btn-primary" id="btnSave" (click)="copy_Transmittal()"><i class="fa fa-copy" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Copy Transmittal</button>
            </div>
        </div>
    </div>
</div>
<form [formGroup]="transmittalForm" autocomplete="off">
    <div class="row eip-pt-10">
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field>
                <mat-label>Template Name</mat-label>
                <input matInput type="text" formControlName="template" required>
                <mat-error *ngIf="transmittalForm.get('template').hasError('required')">
                    Template Name is required
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field>
                <mat-label>Subject</mat-label>
                <input matInput type="text" formControlName="subject" required>
                <mat-error *ngIf="transmittalForm.get('subject').hasError('required')">
                    Subject is required
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field>
                <mat-label>No of Copies</mat-label>
                <input matInput type="number" formControlName="quantity" required>
                <mat-error *ngIf="transmittalForm.get('quantity').hasError('required')">
                    No of Copies is required
                </mat-error>
                <mat-error *ngIf="transmittalForm.get('quantity').hasError('pattern') && !transmittalForm.get('quantity').hasError('required')">
                    Enter Numbers Only
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <EIPAutoComplete ShowTextValueField='N' setId="categoryTemp" formControlName="formCategory" TextField="dedDescription"  ValueField="dedId" WaterMarkText="Category *" [IsCascading]='true' [dataSource]='categoryList' ShowTextValueField='N' [defaultValue]="selectedCategory" (valueChange)='onselectedValueChange($event,"transmittal","category")' [SingleValueBind]="false">
            </EIPAutoComplete>
            <mat-error *ngIf="transmittalForm.get('formCategory').touched && transmittalForm.get('formCategory').hasError('required')" style="margin-top: -15px;">
                Category is required
            </mat-error>
        </div>
        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12">
            <mat-form-field>
                <mat-label>Remarks</mat-label>
                <input matInput type="text" formControlName="remarks">
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <EIPAutoComplete ShowTextValueField='N' setId="fromMembers" formControlName="formFromMember" TextField="memberName"  ValueField="memberId" WaterMarkText="From *" [IsCascading]='true' [dataSource]='masterMembers' ShowTextValueField='N' [defaultValue]="selectedFrom" (valueChange)='onselectedValueChange($event,"transmittal","fromMember")'>
            </EIPAutoComplete>
            <mat-error *ngIf="transmittalForm.get('formFromMember').touched && transmittalForm.get('formFromMember').hasError('required')" style="margin-top: -15px;">
                From is required
            </mat-error>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <EIPAutoComplete ShowTextValueField='N' setId="toMembers" formControlName="formToMember" TextField="memberName"  ValueField="memberId" WaterMarkText="To *" [IsCascading]='true' [dataSource]='masterMembers' ShowTextValueField='N' [defaultValue]="selectedTo" (valueChange)='onselectedValueChange($event,"transmittal","toMember")'>
            </EIPAutoComplete>
            <mat-error *ngIf="transmittalForm.get('formToMember').touched && transmittalForm.get('formToMember').hasError('required')" style="margin-top: -15px;">
                To is required
            </mat-error>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <mat-form-field style="width: 100%;">
                <mat-label>Cc</mat-label>
                <mat-chip-list #ccChipList required formControlName="ccMembers">
                    <ng-container *ngFor="let member of ccMembers">
                        <mat-chip color="primary" [selectable]="selectable" [removable]="removable" (removed)="removeCc(member)">
                            {{member.memberName}}
                            <i matChipRemove class="fa fa-times-circle" title="Close" aria-hidden="true"></i>
                        </mat-chip>
                    </ng-container>
                    <input #ccInput (focus)="matCcAutoComplete.showPanel = true" formControlName="ccMembersCtrl" [matAutocomplete]="ccauto" [matChipInputFor]="ccChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur">
                </mat-chip-list>
                <mat-error *ngIf="transmittalForm.controls['ccMembers'].hasError('required')">
                    Please select any member
                </mat-error>
                <mat-error *ngIf="!transmittalForm.controls['ccMembers'].hasError('required') && transmittalForm.controls['ccMembers'].errors?.IsError">
                    Please select the value only from the available list
                </mat-error>
                <mat-autocomplete #ccauto="matAutocomplete" (optionsScroll)="onScroll()">
                    <mat-option *ngFor="let member of ccFilteredMembers | async" [value]="member">
                        <div (click)="optionClicked($event, member,'cc')">
                            <mat-checkbox [checked]="isMemberSelected(member,'cc')" (change)="toggleCcSelection(member)" (click)="$event.stopPropagation()">
                                {{member.groupName}}
                            </mat-checkbox>
                        </div>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
</form>
<div class="row" *ngIf="ccMembers.length > 0">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <table style="border: 1px solid #dee2e6; margin-top:10px; width:100%" aria-hidden="true">
            <thead style="background: #1063a1; color: white; border-bottom: 2px solid #dee2e6;">
                <tr style="border-bottom: 1px solid #dee2e6;">
                    <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;">
                        Sl. No.</th>
                    <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6;">Assigned Cc</th>
                    <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6;">Group By</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let member of ccMembers;let i=index" style="background-color: #f2f0f0; border-bottom: 1px solid #dee2e6;">
                    <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;">{{i+1}}</td>
                    <td style="padding: 5px 10px; border-right: 1px solid #dee2e6;">{{member.memberName}}</td>
                    <td style="padding: 5px 10px; border-right: 1px solid #dee2e6;">
                        <input type="number" required [value]="getGroupByValue(member)" (change)="onGroupByChange($event.target.value,member)">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="row eip-mt-20">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <button class="btn btn-primary" id="btnGroupView" (click)="showGroupView()"><i class="fa fa-team-management" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Distribution View</button>
    </div>
</div>
<div class="eip-mt-20" [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
    <kendo-grid [kendoGridBinding]="distributionList" [reorderable]="true" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [pageSize]="15" [pageable]="true" (cellClick)="cellClickHandler($event)" (edit)="editRowData($event)" (save)="UpdateRowData($event)" (cancel)="cancelRowData($event)">
        <ng-template kendoPagerTemplate>
            <div class="k-pager-left">
                <kendo-pager-info></kendo-pager-info>
            </div>
            <div class="k-pager-right">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-input></kendo-pager-input>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
        </ng-template>
        <ng-template kendoGridToolbarTemplate>
            <div class="k-grid-toolbar-content d-flex">
                <div class="flex-grow-1 mat-panel-headerbar"></div>
                <div class="pagination-container">
                    <p id="lblShowDetails">Show</p>
                    <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                    </kendo-pager-page-sizes>
                    <span>Items</span>
                </div>
                <div class="divider-container d-none d-md-block" id="imgDivider">
                    <span></span>
                </div>
                <div class="icons-container">
                    <i class="fa fa-cancel" *ngIf="formGroup" (click)="cancelHandler()" title="Close" aria-hidden="true"></i>
                </div>
            </div>
        </ng-template>
        <kendo-grid-column title="Sl.No." field="slno" width="60">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                {{rowIndex+1}}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Group" field="receiver_Group" width="80" visible="false">
        </kendo-grid-column>
        <kendo-grid-column title="Name" field="name" width="250">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span [innerHtml]="getMemberNames(dataItem.members)" style="display: block;word-wrap:break-word;white-space: normal;"></span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="No of Copies" field="quantity" width="150">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span [innerHtml]="dataItem.quantity" style="display: block;word-wrap:break-word;white-space: normal;"></span>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <mat-form-field>
                    <mat-label>No of Copies</mat-label>
                    <input type="number" matInput width="50" [value]="dataItem.quantity" (change)="qtyChange($event);" formControlName="quantity" required autocomplete="off">
                </mat-form-field>
                <mat-error *ngIf="formGroup.get('quantity').hasError('required')" style="margin-top: -15px;">
                    No of Copies is required
                </mat-error>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Category" field="category" width="170">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span [innerHtml]="getElementDesc(dataItem.category)" style="display: block;word-wrap:break-word;white-space: normal;"></span>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <EIPAutoComplete ShowTextValueField='N' setId="category" formControlName="category" TextField="dedDescription"  ValueField="dedId" WaterMarkText="Category *" [IsCascading]='true' required [dataSource]='categoryList' ShowTextValueField='N' (valueChange)='onCategoryChange($event)' [clearValue]='Y' [defaultValue]="selected_Category">
                </EIPAutoComplete>
                <mat-error *ngIf="formGroup.get('category').hasError('required')" style="margin-top: -15px;">
                    Category is required
                </mat-error>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Type" field="type" width="170">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span [innerHtml]="getElementType(dataItem.type)" style="display: block;word-wrap:break-word;white-space: normal;"></span>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <EIPMultiSelectAutoComplete [dataSource]="copyTypeList" required formControlName="type" setId="type" TextField="dedDescription" ValueField="dedId" isEmitOnSelect="Y" WaterMarkText="Type *" ShowTextValueField='N' [IsCascading]='true' [defaultSelectedValues]="selected_Type" (valueChange)='onTypeChange($event)'>
                </EIPMultiSelectAutoComplete>
                <mat-error *ngIf="formGroup.get('type').hasError('required')" style="margin-top: -15px;">
                    Type is required
                </mat-error>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Remarks" field="remarks" width="250">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span [innerHtml]="dataItem.remarks" style="display: block;word-wrap:break-word;white-space: normal;"></span>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <mat-form-field>
                    <textarea rows="1" matInput [value]="dataItem.remarks" (change)="remarkChange($event);"></textarea>
                </mat-form-field>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Actions" width="250">
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem="dataItem">
                <div>
                    <button kendoGridEditCommand class="k-grid-add-command">
                        <i class="fa fa-pencil icon-size mr-2" matTooltip="Edit" style="font-size: 20px;" id="" aria-hidden="true"></i>
                    </button>
                    <button kendoGridSaveCommand type="button" class="k-grid-add-command">
                        <i class="fa fa-save icon-size mr-2" matTooltip="Save" style="font-size: 20px;" id="" aria-hidden="true"></i>
                    </button>
                    <button kendoGridCancelCommand type="button" class="k-grid-add-command">
                        <i class="fa fa-times-circle icon-size mr-2" matTooltip="Cancel" style="font-size: 20px;" id="" aria-hidden="true"></i>
                    </button>
                </div>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>
<div class="row">
    <div class="col-12">
        <div class="text-right eip-mt-10 eip-mb-10">
            <button class="btn btn-primary" id="btnSave" (click)="saveTransmittalTemplate()" [disabled]="!transmittalForm.valid"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save</button>&nbsp;
            <button class="btn btn-secondary" id="btnCancel" (click)="cancelTransmittalTemplate()"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Cancel</button>
        </div>
    </div>
</div>